// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__bAD12","file":"styles_file__rJXkB"};